import { DOM } from "./dom"
import { str } from "./str"
export class Template {
    constructor(id,define){
        // Test to see if the browser supports the HTML template element by checking
        // for the presence of the template element's content attribute.
        /**
         * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/template
         */
        if ('content' in DOM.element('template')) {
            this.template = DOM.element(id) // get element
            if(define)
                this.define(id,define) // render as web component
            const element = this.template.content.firstElementChild.cloneNode(true) // clone content
            element.dataset.template = id // set data-template attribute
            element.setAttribute('id',id+'-'+str.getRandom(32)) // set id
            return element
        }
    }
    // define web component <[define]-[id]></[define]-[id]>
    define(id,define = 'template') {
        customElements.define(
            `${define}-${id}`, // set tag
            class extends HTMLElement {
              constructor() {
                super()
                const shadowRoot = this.attachShadow({ mode: "open" })
                shadowRoot.appendChild(document.getElementById(id).content.cloneNode(true))
              }
            }
          )
    }
}
